import Head from 'expo-router/head';

import { OtherTermsScreen } from '../../../components/more-screen/other-terms-screen';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function OtherTermsRoute() {
  return (
    <>
      <Head>
        <title>Other Terms &amp; Policies - Firehouse Subs</title>
      </Head>
      <OtherTermsScreen />
    </>
  );
}
